import { Box } from '@mui/material'
import { EditProductionMUITable } from './EditProduction.MUITable'
import { useProduction } from './EditProduction.data'
import { EditProductionViewProps } from './EditProduction.types'
import { useNavigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useWorkcentreRunStatus } from 'Features/PlannedVolume/PlannedVolume.data'
import { WORKCENTRE_STATUS } from 'Common/Constants/Constants'
import toast from 'react-hot-toast'
import { Loader } from 'Common/Loader/Loader'

export const EditProductionView = ({
  planId,
  workcentreId,
  sourcesiteId,
}: EditProductionViewProps) => {
  const { data, isLoading } = useProduction({
    planId,
    workcentreId,
    sourcesiteId,
  })

  const navigate = useNavigate()

  const [isAnyWorkcentreRunning, setIsAnyWorkcentreRunning] = useState(false)
  const isAnyWorkcentreRunningRef = useRef(false)
  const [isSavePending, setIsSavePending] = useState(false)

  const { data: workcentreRunStatus, isLoading: workCentreRunStatusLoading } =
    useWorkcentreRunStatus({ planId, sourcesiteId, workcentreId })

  useEffect(() => {
    if (workcentreRunStatus) {
      let intervalId: NodeJS.Timeout
      setIsAnyWorkcentreRunning(
        workcentreRunStatus?.is_any_workcentre_being_run ?? false
      )
      if (
        workcentreRunStatus &&
        (workcentreRunStatus?.status === WORKCENTRE_STATUS.INITIATED ||
          workcentreRunStatus?.status === WORKCENTRE_STATUS.RUNNING)
      ) {
        setIsSavePending(false)
        intervalId = setTimeout(() => {
          navigate(`/plan/${planId}`)
        }, 1000)

        return () => {
          clearInterval(intervalId)
        }
      }
    }
  }, [workcentreRunStatus])

  useEffect(() => {
    if (isAnyWorkcentreRunning) {
      isAnyWorkcentreRunningRef.current = true
      toast.error(
        'Another workcentre is being run. Check back later to edit plan for this workcentre.',
        {
          duration: 10000 * 60,
        }
      )
    } else if (
      isAnyWorkcentreRunning === false &&
      isAnyWorkcentreRunningRef.current === true
    ) {
      isAnyWorkcentreRunningRef.current = false
      toast.dismiss()
      toast.success(
        'Other workcentre finished running. Now you can save your changes.'
      )
    }
  }, [isAnyWorkcentreRunning])

  if (workCentreRunStatusLoading) {
    return <Loader />
  }

  return (
    <Box>
      <EditProductionMUITable
        data={Object.values(data?.result ?? {}) ?? []}
        isLoading={isLoading}
        weeks={data?.weeks ?? []}
        planId={planId}
        workcentreId={workcentreId}
        sourcesiteId={sourcesiteId}
        isAnyWorkcentreRunning={isAnyWorkcentreRunning}
        setIsSavePending={setIsSavePending}
      />
    </Box>
  )
}
